var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { TipoParcelaEnum } from './TipoParcelaEnum';
import { CustomRadioGroup } from './Forms/CustomRadioGroup';
import { Grid } from '@mui/material';
export var DadosPecasTecParcela = function (_a) {
    var _b = _a.label, label = _b === void 0 ? 'Peças Técnicas ' : _b, _c = _a.name, name = _c === void 0 ? 'pecasTecnicas' : _c, handleOnChangePecas = _a.handleOnChangePecas, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.isView, isView = _e === void 0 ? false : _e, _f = _a.required, required = _f === void 0 ? true : _f, setPecasObject = _a.setPecasObject, _g = _a.options, options = _g === void 0 ? [] : _g, pecasObject = _a.pecasObject;
    var handleChangePecasTecnicas = function (value) {
        if (disabled) {
            return;
        }
        setPecasObject === null || setPecasObject === void 0 ? void 0 : setPecasObject(TipoParcelaEnum.getPecaEnumKey(value));
        handleOnChangePecas === null || handleOnChangePecas === void 0 ? void 0 : handleOnChangePecas(value);
    };
    var renderOptions = useMemo(function () {
        return ((options === null || options === void 0 ? void 0 : options.length) === 0 ? TipoParcelaEnum.getConvSigefOptions() : options);
    }, [options]);
    return (_jsx(Grid, __assign({ container: true, spacing: 2 }, { children: _jsx(Grid, __assign({ item: true, xs: 12, style: { padding: '31px' } }, { children: _jsx(CustomRadioGroup, { onChange: function (event) { return handleChangePecasTecnicas(event.target.value); }, disabled: disabled || isView, options: renderOptions, value: pecasObject, required: required, label: label, name: name, collumn: true }) })) })));
};
